import React from 'react';
// import fullData from '../../data/channel_tree.json';
import { SubAccount, ClientsAPI } from "src/api"

import TreeMap, { Tooltip } from 'devextreme-react/tree-map';


type Data = Array<{
  devices: string,
  devices_data: Array<{
    period: number,
    channel_info: Array<{
      sessions: number,
      channel: string
    }>
  }>
}>



type TreeProps = {
  client?: SubAccount
}
class TreeChannel extends React.Component<TreeProps> {
  state = {
    data: undefined,
    narrative: undefined

  }

  fetchData = (client: SubAccount) => {
    const params = {
      narrative_assembly_id: "444df7a8-f157-11ea-86cf-0e95a518f8f7",
      report_content_id: "6e06762c-8612-4034-8f0b-bf27bca71702",
      sub_account_id: client.id,
      period_index: "1449",
      period_type: "monthly"
    }

    ClientsAPI.getReportData(client, 'channel_tree.json').then(result => {
      // console.log('done')
      // console.log('done', result)
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })

    ClientsAPI.getNarrative(client, params).then(result => {
      // console.log('done', result)
      this.setState({ narrative: result[0] });
    }).catch(error => {
      // console.log('error', error)
    })
  }
  parseData = (OriginData: any) => {
    const sessionNames = ['Organic Search', 'Paid Search', 'Referral', 'Social']

    const result = []
    for (const oneRawData of OriginData) {
      const sums = []
      for (let i = 0; i < 4; i++) {
        const sum = oneRawData.devices_data.slice(-3)
          .reduce((a: any, b: { channel_info: { sessions: any; }[]; }) => {
            return a + (b.channel_info[i]?.sessions || 0);// deals with undefined cases
          }, 0);
        sums.push({ value: sum, name: `${sessionNames[i]}\n${sum}` })
      }
      result.push({ name: oneRawData.devices, items: sums })
    }
    return result;
  }
  customizeTooltip(arg: { node: { data: any; isLeaf: () => any; }; valueText: any; }) {
    const data = arg.node.data;

    return {
      text: arg.node.isLeaf() ?
        `<span class="channel">${data.name}</span> <br/>Sum: ${arg.valueText}` :
        null
    };
  }
  // console.log(JSON.stringify(parseData(fullData), null, 2));

  render() {

    const { data, narrative } = this.state;
    const { client } = this.props;
    // const { narrative } = this.state
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;

    return (
      <>
        <TreeMap
          id="treemap"
          dataSource={this.parseData(data)}
          title="Channels Tree Chart"
          colorizer={{
            type: 'discrete',
            palette: 'Soft Blue',
            colorizeGroups: false
          }}
        >
          <Tooltip
            enabled={true}
            // format="thousands"
            customizeTooltip={this.customizeTooltip}
          />
        </TreeMap>
        {JSON.stringify(narrative, null, 2)}
      </>);
  }


}
export default TreeChannel;


// WEBPACK FOOTER //
// ./src/components/ReportComponents/TreeChannel.tsx